import { computed } from '@angular/core';
import {
	patchState,
	signalStore,
	withComputed,
	withHooks,
	withMethods,
	withState,
} from '@ngrx/signals';

export interface ITaskSummary {
	userId: number;
	remainingTaskCount: number;
	overdueTaskCount: number;
	newTaskCount: number;
}

type TaskNotificationState = {
	hubStatus: string;
	taskSummary: ITaskSummary;
};

const initialState: TaskNotificationState = {
	hubStatus: 'disconnected',
	taskSummary: null,
};

export const TaskNotificationStore = signalStore(
	{ providedIn: 'root' },

	withState(initialState),

	withComputed((store) => {
		return {
			remainingTaskCount: computed(() => {
				const userTask = store.taskSummary();
				return userTask?.remainingTaskCount ?? 0;
			}),
			overdueTaskCount: computed(() => {
				const userTask = store.taskSummary();
				return userTask?.overdueTaskCount ?? 0;
			}),
			newTaskCount: computed(() => {
				const userTask = store.taskSummary();
				return userTask?.newTaskCount ?? 0;
			}),
		};
	}),

	withMethods((store) => {
		return {
			setHubStatus: (status: string) => {
				patchState(store, { hubStatus: status.toLowerCase() });
			},
			setTaskSummary: (summary: ITaskSummary) => {
				patchState(store, { taskSummary: summary });
			},
			signOff: () => patchState(store, initialState),
		};
	}),

	withHooks({
		onInit(store) {
			// console.log('onInit', store);
		},
	})
);
